import styled from "styled-components";
import ShortLogo from 'assets/media/images/pagii-chatshop-logo-trimmed.svg';

interface FooterProps {
  sidebar: string;
}

export default function Header({ sidebar }: FooterProps) {
  return (
    <FooterContainer sidebar={sidebar}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img 
          src={ShortLogo} 
          alt="Pagii Logo" 
          style={{ height: '30px', width: '30px' }}
        />
        <span>Copyright 2025 Pagii Chatshop All rights reserved.</span>
      </div>
    </FooterContainer>
  );
}

const FooterContainer = styled.footer<FooterProps>`
  height: 60px;
  width: ${(p) =>
    p.sidebar === "true" ? "calc(100%-250px)" : "calc(100%-5rem)"};
  margin-left: ${(p) => (p.sidebar === "true" ? "250px" : "5rem")};
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: margin-left 0.4s ease-in, width 0.4s ease-in;
  border-top: 1px solid #dee2e6;
  padding: 0 1%;
`;